var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":"/images/kwelite2.png","alt":"KW Elite, Realtors - Keller Williams"}})}
var staticRenderFns = []

export { render, staticRenderFns }